

export const helperMascaras = {
  cep, cnpjCpf
};

function soNumeros(value){
  return value.replace(/\D/g,"")
 }

function cep(value){
  value = ("00000000" + soNumeros(value)).slice(-8);
  value = value.replace(/^(\d{5})(\d)/,"$1-$2")
  return value

}

function cnpjCpf(value)
{
  const cnpjCpf = value.replace(/\D/g, '');
  
  if (cnpjCpf.length === 11) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  } 
  
  return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
}
